export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-02-01 at 21.00.35.d561b3b3.jpeg";